@if (showChrome()) {
<app-header></app-header>
}

<router-outlet (activate)="pageReady.set(true)" />

<!-- Held back until the first page has rendered: while a lazy page's code is
     still downloading, the footer would otherwise sit alone under the header. -->
@if (showChrome() && pageReady()) {
<app-footer></app-footer>
}

<!-- Outlet for NotificationService / the error interceptor. -->
<p-toast position="top-right" />
